export { default as metaReducer } from './reducer';
export type { MetaState } from './reducer';
